import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AdminLoginPage } from "@/features/admin-auth";

const loginSearchSchema = z.object({
  next: z.string().optional(),
  reason: z.enum(["session_expired", "unauthorized"]).optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: loginSearchSchema,
  component: AdminLoginPage,
});
